import { render } from "./SystemLogTableView.vue?vue&type=template&id=4a75be94"
import script from "./SystemLogTableView.vue?vue&type=script&lang=js"
export * from "./SystemLogTableView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__